import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog } from '../../common/components';
import LegalEntitiesDataTable from './components/LegalEntitiesDataTable';
import LegalEntitiesPagination from './components/LegalEntitiesPagination';
import LegalEntityDialog from './components/LegalEntityDialog';
import { useLegalEntitiesTable } from './hooks/useLegalEntitiesTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const LegalEntitiesTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedLegalEntity,
    countries,
    provinces,
    departments,
    districts,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleSave,
    handleEdit,
    handleDelete,
    deleteConfirmOpen,
    entityToDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useLegalEntitiesTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <Box>
      <FormTitleBox
        title="Entidades | Personas Jurídicas"
        showButton={true}
        buttonText="Agregar Persona Jurídica"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar persona jurídica"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <LegalEntitiesDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        LoadingComponent={LoadingSkeleton}
      />

      <LegalEntitiesPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <LegalEntityDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedLegalEntity={selectedLegalEntity}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        countries={countries}
        provinces={provinces}
        departments={departments}
        districts={districts}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="persona jurídica"
        message={`¿Está seguro que quiere eliminar la persona jurídica "${
          entityToDelete?.company || ''
        }" de forma permanente?`}
      />
    </Box>
  );
};

export default LegalEntitiesTable;
